var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"f-block-list"},_vm._l((_vm.blocks),function(b){return _c('footer-block',{key:b.path,attrs:{"block":b}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }